import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-528676dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "confirm-assign-modal-body" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Do you wants to assign your certificate & specialisms?"),
  /*#__PURE__*/_createElementVNode("p", null, " Once enabled, Contractors will be able to request site visits for properties listed in this project, if required. ")
], -1))
const _hoisted_2 = { class: "confirm-assign-modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_GeneralDialog = _resolveComponent("GeneralDialog")!

  return (_openBlock(), _createBlock(_component_GeneralDialog, null, {
    body: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_v_btn, {
          class: "button button-purple-border",
          onClick: $setup.onclickNo
        }, {
          default: _withCtx(() => [
            _createTextVNode("NO")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_v_btn, {
          onClick: $setup.onClickYes,
          class: "button button-orange"
        }, {
          default: _withCtx(() => [
            _createTextVNode("YES")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }))
}